export default __webpack_public_path__ + "static/media/0114.0d4042c9.png";